import { render, staticRenderFns } from "./answerModal.vue?vue&type=template&id=6fb038db&scoped=true&"
import script from "./answerModal.vue?vue&type=script&lang=js&"
export * from "./answerModal.vue?vue&type=script&lang=js&"
import style0 from "./answerModal.vue?vue&type=style&index=0&id=6fb038db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb038db",
  null
  
)

export default component.exports